<template>
  <div class="home-container">
    <div class="top">
      <div class="top-main">
        <img src="../img/logo.png">
        <p>三生万物</p>
        <el-button type="primary" plain @click="loginOut">退出</el-button>
      </div>
    </div>
    <div class="main">
      <div class="left">
        <leftSide :liData="liData"></leftSide>
      </div>
      <div class="content">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import leftSide from "../components/leftSide.vue";

export default {
  name: "home",
  components: {
    leftSide
  },
  data() {
    return {
      liData: [
        {
          title: '企业信息',
          href: '/home/company'
        },
        {
          title: '品种信息',
          href: '/home/variety'
        },
        {
          title: '追溯码信息',
          href: '/home/code'
        },
        {
          title: '小程序管理员信息',
          href: '/home/appletAdministrator'
        },
        {
          title: '一级经销商信息',
          href: '/home/firstAgent'
        },
      ]
    }
  },
  methods: {
    loginOut() {
      console.log(sessionStorage.clear())
      this.$router.push({path: '/login'});
    }
  }
}
</script>

<style scoped lang="scss">
.home-container {
  .top {
    height: 60px;
    background-color: #3d3d3d;

    .top-main {
      width: 1600px;
      margin: 0 auto;
      height: 100%;

      img {
        width: 50px;
        height: 50px;
        margin-top: 5px;
        float: left;
      }

      p {
        float: left;
        color: white;
        font-size: 25px;
        margin-left: 30px;
        line-height: 60px;
      }

      .el-button {
        float: right;
        margin-top: 10px;
      }
    }
  }

  .main {
    width: 1600px;
    margin: 0 auto;
    overflow: hidden;

    .left {
      float: left;
    }

    .content {
      width: 1385px;
      float: left;
      border-left: 5px solid #ff765b;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/home.vue